// extracted by mini-css-extract-plugin
module.exports = {"categoryUpsertModal":"CategoryUpsertModal_categoryUpsertModal__D9Phv","header":"CategoryUpsertModal_header__GuEVA","actions":"CategoryUpsertModal_actions__3eCqt"};